import { jsx as r, jsxs as l } from "react/jsx-runtime";
import n from "../../components/card-wrapper.mjs";
import p from "../../components/item-thumbnail-base.mjs";
import f from "../../ui-kit/theme-button.mjs";
import { StoreImageEnum as h } from "../../enums/store-image-enum.mjs";
const T = ({
  thumbnail: e,
  url: m,
  buttonTitle: i,
  subTitle: o,
  title: t,
  headingLevel: a
}) => /* @__PURE__ */ r(n, { children: /* @__PURE__ */ l("div", { className: "flex flex-col gap-3", children: [
  /* @__PURE__ */ r(
    p,
    {
      title: t,
      subTitle: o,
      imageType: h.link_thumbnail,
      thumbnail: e,
      headingLevel: a
    }
  ),
  /* @__PURE__ */ r(f, { href: m, children: i })
] }) });
export {
  T as default
};
